import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Recibo } from '../../model/poliza.model';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CaButtonComponent } from '@global-front-components/ui/button';
import { CaIcon } from '@global-front-components/ui/form-field';
import { CaModalOverlayService, ModalConfig } from '@global-front-components/ui/modal-overlay';
import { ModalInformacionTarificacionComponent } from '../modal-informacion-tarificacion/modal-informacion-tarificacion.component';

@Component({
	selector: 'app-tarificacion',
	standalone: true,
	imports: [
		CommonModule,
		CaButtonComponent,
		CaIcon,
		TranslateModule
	],
	templateUrl: './tarificacion.component.html',
	styleUrls: ['./tarificacion.component.scss']
})
export class TarificacionComponent implements OnInit{
	@Input() recibo!: Recibo;
	@Output() contratarEmitter = new EventEmitter<Recibo>();
	modalConfig: ModalConfig;
	
	constructor(
		private _modalService: CaModalOverlayService,	
		private translateService: TranslateService
	){}

	contratar(){
		this.contratarEmitter.emit(this.recibo);
	}

	abrirModal(): void {
		this.translateService.get('COMUN.DATOS_ECONOMICOS.DESGLOSE')
			.subscribe(title => {
				const modalConfig  = this.modalConfig;
				modalConfig.data = { recibo: this.recibo };
				modalConfig.title = title;
				this._modalService.open(ModalInformacionTarificacionComponent, modalConfig);
		});
	}

	ngOnInit(): void {
		this.modalConfig = {
			windowDrag: true,
			backdropClick: true,
			isBodyScrollable: true,
			closable: true,
			minimizable: false,
			maximizable: false,
		};
	}

}
